// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@300;400;500;600;700;800&family=Lora:ital,wght@0,400;0,600;1,400&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ======================================
   DESIGN TOKENS — Pyate Blue Brand
   Matched to: white navbar, #f0f2f5 page bg,
   #1565C0 / #1976D2 primary blue
====================================== */
:root {
  --brand:          #1565C0;
  --brand-mid:      #1976D2;
  --brand-light:    #42A5F5;
  --brand-soft:     #E8F1FB;
  --brand-glow:     rgba(21, 101, 192, 0.15);
  --brand-glow-md:  rgba(21, 101, 192, 0.25);
  --accent:         #0097A7;
  --accent-soft:    #E0F4F7;
  --surface:        #ffffff;
  --surface-2:      #F5F7FA;
  --surface-3:      #EBF1FB;
  --page-bg:        #F0F2F5;        /* matches app grey background */
  --border:         #DCE8F8;
  --border-strong:  #BBCFF5;
  --text-primary:   #0C1A2E;
  --text-secondary: #334D6E;
  --text-muted:     #7090B0;
  --success:        #16A34A;
  --danger:         #DC2626;
  --danger-soft:    #FFF0F0;
  --font:           'Plus Jakarta Sans', sans-serif;
  --font-serif:     'Lora', serif;
  --ease:           cubic-bezier(0.16, 1, 0.3, 1);
  --radius-sm:      8px;
  --radius-md:      14px;
  --radius-lg:      22px;
  --shadow-sm:      0 1px 3px rgba(0,0,0,0.06), 0 4px 12px rgba(21,101,192,0.06);
  --shadow-md:      0 4px 16px rgba(0,0,0,0.07), 0 12px 32px rgba(21,101,192,0.09);
  --shadow-lg:      0 8px 30px rgba(0,0,0,0.10), 0 24px 56px rgba(21,101,192,0.12);
  --shadow-focus:   0 0 0 3px rgba(21,101,192,0.18);
}

* { box-sizing: border-box; }

/* ======================================
   PAGE BACKGROUND — matches app grey
====================================== */
body {
  background: var(--page-bg);
  min-height: 100vh;
  font-family: var(--font);
}

/* ======================================
   MAIN CONTAINER
====================================== */
.about_container-edit {
  display: flex;
  justify-content: center;
  font-family: var(--font);
  width: 100%;
  max-width: 860px;
  margin: 28px auto;
  border: 1px solid var(--border-strong);
  border-radius: var(--radius-lg);
  overflow: hidden;
  background: var(--surface);
  box-shadow: var(--shadow-md);
  position: relative;
  transition: box-shadow 0.3s var(--ease);
}

.about_container-edit:hover {
  box-shadow: var(--shadow-lg);
}

/* Decorative top accent bar — Pyate blue */
.about_container-edit::before {
  content: '';
  position: absolute;
  top: 0; left: 0; right: 0;
  height: 4px;
  background: linear-gradient(90deg, var(--brand) 0%, var(--brand-light) 60%, var(--accent) 100%);
  z-index: 2;
}

/* ======================================
   CONTENT AREA
====================================== */
.about_content-edit {
  width: 100%;
  padding: 38px 42px 44px;
  text-align: left;
}

/* ======================================
   HEADER
====================================== */
.header-container-edit {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 28px;
  padding-bottom: 18px;
  border-bottom: 2px solid var(--brand-soft);
  position: relative;
}

.header-container-edit h2 {
  font-family: var(--font);
  font-size: 22px;
  font-weight: 800;
  color: var(--brand);
  letter-spacing: -0.4px;
  margin: 0;
  position: relative;
}

.header-container-edit h2::after {
  content: '';
  position: absolute;
  bottom: -20px;
  left: 0;
  width: 36px;
  height: 3px;
  background: linear-gradient(90deg, var(--brand), var(--accent));
  border-radius: 100px;
}

/* Section headings */
.about_content-edit h3 {
  font-family: var(--font);
  font-size: 10.5px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 1.4px;
  color: var(--brand-light);
  margin: 24px 0 8px;
  padding: 0;
}

/* ======================================
   PARAGRAPH CARDS
====================================== */
.paragraph-container-edit {
  margin-bottom: 12px;
  padding: 16px 20px;
  background: var(--surface-2);
  border: 1px solid var(--border);
  border-left: 4px solid var(--brand-soft);
  border-radius: var(--radius-md);
  transition: border-left-color 0.22s var(--ease), box-shadow 0.22s var(--ease), background 0.2s;
}

.paragraph-container-edit:hover {
  border-left-color: var(--brand-mid);
  background: var(--surface);
  box-shadow: var(--shadow-sm);
}

.para-edit {
  font-family: var(--font-serif);
  font-size: 15.5px;
  line-height: 1.8;
  color: var(--text-secondary);
  margin: 0;
}

/* ======================================
   ADDRESS SECTION
====================================== */
.about_content-edit > div {
  background: linear-gradient(135deg, var(--surface-3) 0%, var(--surface-2) 100%);
  border: 1px solid var(--border);
  border-radius: var(--radius-md);
  padding: 18px 22px;
  margin-top: 8px;
}

.about_content-edit > div p {
  font-size: 14px;
  font-weight: 500;
  color: var(--text-secondary);
  margin: 5px 0;
  display: flex;
  align-items: center;
  gap: 8px;
}

.about_content-edit > div p::before {
  content: '▸';
  color: var(--brand-light);
  font-size: 13px;
  line-height: 1;
  flex-shrink: 0;
}

/* Website link */
.about_content-edit a {
  color: var(--brand);
  text-decoration: none;
  font-weight: 600;
  font-size: 14px;
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 2px 0;
  border-bottom: 1.5px solid var(--brand-soft);
  transition: color 0.18s, border-color 0.18s;
}

.about_content-edit a:hover {
  color: var(--accent);
  border-bottom-color: var(--accent);
}

/* No address fallback text */
.about_content-edit > p {
  font-size: 13.5px;
  color: var(--text-muted);
  font-style: italic;
  margin: 8px 0 0;
}

/* ======================================
   EDITABLE INPUTS
====================================== */
.editable-text-edit {
  width: 100%;
  min-height: 130px;
  padding: 13px 16px;
  font-size: 14px;
  font-family: var(--font);
  border: 1.5px solid var(--border-strong);
  border-radius: var(--radius-sm);
  background: var(--surface-2);
  outline: none;
  line-height: 1.7;
  resize: vertical;
  color: var(--text-primary);
  transition: border-color 0.2s, box-shadow 0.2s, background 0.2s;
}

.editable-text-edit:focus {
  border-color: var(--brand-mid);
  box-shadow: var(--shadow-focus);
  background: #fff;
}

.editable-input-edit {
  width: 100%;
  padding: 10px 14px;
  font-size: 14px;
  font-family: var(--font);
  border: 1.5px solid var(--border-strong);
  border-radius: var(--radius-sm);
  background: var(--surface-2);
  outline: none;
  color: var(--text-primary);
  transition: border-color 0.2s, box-shadow 0.2s, background 0.2s;
}

.editable-input-edit:focus {
  border-color: var(--brand-mid);
  box-shadow: var(--shadow-focus);
  background: #fff;
}

/* ======================================
   BUTTONS
====================================== */
.edit_button-edit {
  padding: 8px 20px;
  background: linear-gradient(135deg, var(--brand) 0%, var(--brand-mid) 100%);
  color: white;
  border: none;
  border-radius: 100px;
  cursor: pointer;
  font-family: var(--font);
  font-size: 13px;
  font-weight: 700;
  letter-spacing: 0.1px;
  box-shadow: 0 2px 10px var(--brand-glow);
  transition: transform 0.2s var(--ease), box-shadow 0.2s var(--ease);
  margin-left: 10px;
}

.edit_button-edit:hover {
  transform: translateY(-2px);
  box-shadow: 0 5px 18px var(--brand-glow-md);
}

.add-btn-edit,
.save-btn-edit {
  padding: 8px 20px;
  background: linear-gradient(135deg, var(--brand) 0%, var(--brand-mid) 100%);
  color: white;
  border: none;
  border-radius: 100px;
  cursor: pointer;
  font-family: var(--font);
  font-size: 13px;
  font-weight: 700;
  box-shadow: 0 2px 10px var(--brand-glow);
  transition: transform 0.2s var(--ease), box-shadow 0.2s var(--ease);
}

.add-btn-edit:hover,
.save-btn-edit:hover {
  transform: translateY(-2px);
  box-shadow: 0 5px 18px var(--brand-glow-md);
}

.delete-btn-edit {
  padding: 7px 16px;
  background: var(--danger-soft);
  color: var(--danger);
  border: 1.5px solid #FECACA;
  border-radius: 100px;
  cursor: pointer;
  font-family: var(--font);
  font-size: 12.5px;
  font-weight: 700;
  margin-top: 10px;
  transition: all 0.18s var(--ease);
}

.delete-btn-edit:hover {
  background: var(--danger);
  color: white;
  border-color: var(--danger);
  transform: translateY(-1px);
}

.cancel-btn-edit {
  padding: 8px 20px;
  background: var(--surface-2);
  color: var(--text-secondary);
  border: 1.5px solid var(--border-strong);
  border-radius: 100px;
  cursor: pointer;
  font-family: var(--font);
  font-size: 13px;
  font-weight: 600;
  transition: all 0.18s var(--ease);
}

.cancel-btn-edit:hover {
  background: var(--border);
  color: var(--text-primary);
}

.add-paragraph-edit {
  margin-top: 20px;
}

/* ======================================
   MODAL
====================================== */
.about-modal-overlay {
  position: fixed;
  top: 0; left: 0; right: 0; bottom: 0;
  background: rgba(10, 20, 40, 0.5);
  backdrop-filter: blur(8px);
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
}

.about-modal {
  background: var(--surface);
  border-radius: var(--radius-lg);
  max-width: 780px;
  width: 92%;
  max-height: 90vh;
  overflow-y: auto;
  outline: none;
  box-shadow: var(--shadow-lg);
  border: 1px solid var(--border-strong);
  position: relative;
  top: unset;
  left: unset;
  transform: none;
  animation: modalIn 0.28s var(--ease);
}

@keyframes modalIn {
  from { opacity: 0; transform: scale(0.95) translateY(18px); }
  to   { opacity: 1; transform: scale(1) translateY(0); }
}

.about-modal::before {
  content: '';
  display: block;
  height: 4px;
  background: linear-gradient(90deg, var(--brand) 0%, var(--brand-light) 60%, var(--accent) 100%);
  border-radius: var(--radius-lg) var(--radius-lg) 0 0;
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 22px 30px 18px;
  border-bottom: 1px solid var(--border);
}

.modal-header h2,
.modal-header h3 {
  font-family: var(--font);
  font-size: 18px;
  font-weight: 800;
  color: var(--brand);
  margin: 0;
  letter-spacing: -0.2px;
}

.modal-close-btn {
  background: var(--surface-2);
  border: 1.5px solid var(--border-strong);
  width: 34px;
  height: 34px;
  border-radius: 50%;
  font-size: 16px;
  cursor: pointer;
  color: var(--text-muted);
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.18s var(--ease);
  line-height: 1;
  flex-shrink: 0;
}

.modal-close-btn:hover {
  background: var(--danger-soft);
  border-color: #FECACA;
  color: var(--danger);
}

.modal-content {
  margin: 30px auto;
  padding: 22px 30px;
  width: 100%;
}

.form-section {
  margin-bottom: 24px;
  padding: 20px 22px;
  background: var(--surface-2);
  border: 1px solid var(--border);
  border-radius: var(--radius-md);
}

.form-section h3 {
  margin-bottom: 16px;
  color: var(--brand);
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 1.2px;
}

.form-field {
  margin-bottom: 14px;
}

.form-field label {
  display: block;
  margin-bottom: 5px;
  font-size: 12px;
  font-weight: 700;
  color: var(--text-secondary);
  letter-spacing: 0.2px;
  text-transform: uppercase;
}

.modal-footer {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  padding: 18px 30px 26px;
  border-top: 1px solid var(--border);
  background: var(--surface-2);
}

.paragraph-edit-container {
  margin-bottom: 12px;
  padding: 13px 17px;
  background: var(--surface);
  border: 1px solid var(--border-strong);
  border-radius: var(--radius-sm);
}

/* ======================================
   RESPONSIVE
====================================== */
@media (max-width: 992px) {
  .about_container-edit { width: 95%; margin: 18px auto; }
  .about_content-edit { padding: 26px 26px 30px; }
  .para-edit { font-size: 15px; }
  .editable-text-edit { font-size: 13px; min-height: 80px; }
  .header-container-edit { flex-direction: column; align-items: flex-start; gap: 12px; }
  .edit_button-edit { margin-left: 0; }
}

@media (max-width: 768px) {
  .about_container-edit { width: 96%; margin: 12px auto; }
  .about_content-edit { padding: 22px 18px 26px; }
  .para-edit { font-size: 14px; line-height: 1.7; }
  .editable-text-edit { font-size: 13px; min-height: 70px; }
  .editable-input-edit { font-size: 13px; }
  .edit_button-edit, .add-btn-edit, .delete-btn-edit, .save-btn-edit { padding: 7px 14px; font-size: 12.5px; }
  .header-container-edit { flex-direction: column; align-items: flex-start; gap: 8px; }
  .modal-content { padding: 16px 18px; }
  .modal-header { padding: 16px 18px 12px; }
  .modal-footer { padding: 14px 18px 20px; }
}

@media (max-width: 480px) {
  .about_container-edit { width: 97%; margin: 8px auto; }
  .about_content-edit { padding: 18px 14px 22px; }
  .para-edit { font-size: 13.5px; line-height: 1.65; }
  .editable-text-edit { font-size: 12px; min-height: 55px; }
  .editable-input-edit { font-size: 12px; }
  .edit_button-edit, .add-btn-edit, .delete-btn-edit, .save-btn-edit { padding: 6px 12px; font-size: 12px; }
  .modal-content { padding: 12px 14px; }
  .modal-header { padding: 14px 14px 10px; }
  .modal-footer { padding: 12px 14px 18px; gap: 8px; }
}`, "",{"version":3,"sources":["webpack://./src/components/EditAbout.css"],"names":[],"mappings":"AAEA;;;;wCAIwC;AACxC;EACE,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,0CAA0C;EAC1C,0CAA0C;EAC1C,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB,SAAS,gCAAgC;EAClE,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,iDAAiD;EACjD,+BAA+B;EAC/B,+CAA+C;EAC/C,qBAAqB;EACrB,sBAAsB;EACtB,sBAAsB;EACtB,8EAA8E;EAC9E,gFAAgF;EAChF,gFAAgF;EAChF,iDAAiD;AACnD;;AAEA,IAAI,sBAAsB,EAAE;;AAE5B;;wCAEwC;AACxC;EACE,0BAA0B;EAC1B,iBAAiB;EACjB,wBAAwB;AAC1B;;AAEA;;wCAEwC;AACxC;EACE,aAAa;EACb,uBAAuB;EACvB,wBAAwB;EACxB,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,sCAAsC;EACtC,+BAA+B;EAC/B,gBAAgB;EAChB,0BAA0B;EAC1B,4BAA4B;EAC5B,kBAAkB;EAClB,uCAAuC;AACzC;;AAEA;EACE,4BAA4B;AAC9B;;AAEA,2CAA2C;AAC3C;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM,EAAE,OAAO,EAAE,QAAQ;EACzB,WAAW;EACX,+FAA+F;EAC/F,UAAU;AACZ;;AAEA;;wCAEwC;AACxC;EACE,WAAW;EACX,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;;wCAEwC;AACxC;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,oBAAoB;EACpB,0CAA0C;EAC1C,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;EACxB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,sBAAsB;EACtB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,aAAa;EACb,OAAO;EACP,WAAW;EACX,WAAW;EACX,+DAA+D;EAC/D,oBAAoB;AACtB;;AAEA,qBAAqB;AACrB;EACE,wBAAwB;EACxB,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,yBAAyB;EACzB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;;wCAEwC;AACxC;EACE,mBAAmB;EACnB,kBAAkB;EAClB,4BAA4B;EAC5B,+BAA+B;EAC/B,wCAAwC;EACxC,+BAA+B;EAC/B,8FAA8F;AAChG;;AAEA;EACE,mCAAmC;EACnC,0BAA0B;EAC1B,4BAA4B;AAC9B;;AAEA;EACE,8BAA8B;EAC9B,iBAAiB;EACjB,gBAAgB;EAChB,4BAA4B;EAC5B,SAAS;AACX;;AAEA;;wCAEwC;AACxC;EACE,+EAA+E;EAC/E,+BAA+B;EAC/B,+BAA+B;EAC/B,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,4BAA4B;EAC5B,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,YAAY;EACZ,yBAAyB;EACzB,eAAe;EACf,cAAc;EACd,cAAc;AAChB;;AAEA,iBAAiB;AACjB;EACE,mBAAmB;EACnB,qBAAqB;EACrB,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,4CAA4C;EAC5C,2CAA2C;AAC7C;;AAEA;EACE,oBAAoB;EACpB,kCAAkC;AACpC;;AAEA,6BAA6B;AAC7B;EACE,iBAAiB;EACjB,wBAAwB;EACxB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;;wCAEwC;AACxC;EACE,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,wBAAwB;EACxB,wCAAwC;EACxC,+BAA+B;EAC/B,4BAA4B;EAC5B,aAAa;EACb,gBAAgB;EAChB,gBAAgB;EAChB,0BAA0B;EAC1B,+DAA+D;AACjE;;AAEA;EACE,8BAA8B;EAC9B,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,wBAAwB;EACxB,wCAAwC;EACxC,+BAA+B;EAC/B,4BAA4B;EAC5B,aAAa;EACb,0BAA0B;EAC1B,+DAA+D;AACjE;;AAEA;EACE,8BAA8B;EAC9B,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;;wCAEwC;AACxC;EACE,iBAAiB;EACjB,2EAA2E;EAC3E,YAAY;EACZ,YAAY;EACZ,oBAAoB;EACpB,eAAe;EACf,wBAAwB;EACxB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,wCAAwC;EACxC,mEAAmE;EACnE,iBAAiB;AACnB;;AAEA;EACE,2BAA2B;EAC3B,2CAA2C;AAC7C;;AAEA;;EAEE,iBAAiB;EACjB,2EAA2E;EAC3E,YAAY;EACZ,YAAY;EACZ,oBAAoB;EACpB,eAAe;EACf,wBAAwB;EACxB,eAAe;EACf,gBAAgB;EAChB,wCAAwC;EACxC,mEAAmE;AACrE;;AAEA;;EAEE,2BAA2B;EAC3B,2CAA2C;AAC7C;;AAEA;EACE,iBAAiB;EACjB,8BAA8B;EAC9B,oBAAoB;EACpB,2BAA2B;EAC3B,oBAAoB;EACpB,eAAe;EACf,wBAAwB;EACxB,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,2BAA2B;EAC3B,2BAA2B;AAC7B;;AAEA;EACE,iBAAiB;EACjB,4BAA4B;EAC5B,4BAA4B;EAC5B,wCAAwC;EACxC,oBAAoB;EACpB,eAAe;EACf,wBAAwB;EACxB,eAAe;EACf,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;wCAEwC;AACxC;EACE,eAAe;EACf,MAAM,EAAE,OAAO,EAAE,QAAQ,EAAE,SAAS;EACpC,iCAAiC;EACjC,0BAA0B;EAC1B,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,0BAA0B;EAC1B,+BAA+B;EAC/B,gBAAgB;EAChB,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,4BAA4B;EAC5B,sCAAsC;EACtC,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,eAAe;EACf,oCAAoC;AACtC;;AAEA;EACE,OAAO,UAAU,EAAE,uCAAuC,EAAE;EAC5D,OAAO,UAAU,EAAE,iCAAiC,EAAE;AACxD;;AAEA;EACE,WAAW;EACX,cAAc;EACd,WAAW;EACX,+FAA+F;EAC/F,oDAAoD;AACtD;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,uBAAuB;EACvB,sCAAsC;AACxC;;AAEA;;EAEE,wBAAwB;EACxB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,SAAS;EACT,sBAAsB;AACxB;;AAEA;EACE,4BAA4B;EAC5B,wCAAwC;EACxC,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,wBAAwB;EACxB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iCAAiC;EACjC,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,8BAA8B;EAC9B,qBAAqB;EACrB,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,4BAA4B;EAC5B,+BAA+B;EAC/B,+BAA+B;AACjC;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,4BAA4B;EAC5B,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,uBAAuB;EACvB,mCAAmC;EACnC,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,0BAA0B;EAC1B,sCAAsC;EACtC,+BAA+B;AACjC;;AAEA;;wCAEwC;AACxC;EACE,wBAAwB,UAAU,EAAE,iBAAiB,EAAE;EACvD,sBAAsB,uBAAuB,EAAE;EAC/C,aAAa,eAAe,EAAE;EAC9B,sBAAsB,eAAe,EAAE,gBAAgB,EAAE;EACzD,yBAAyB,sBAAsB,EAAE,uBAAuB,EAAE,SAAS,EAAE;EACrF,oBAAoB,cAAc,EAAE;AACtC;;AAEA;EACE,wBAAwB,UAAU,EAAE,iBAAiB,EAAE;EACvD,sBAAsB,uBAAuB,EAAE;EAC/C,aAAa,eAAe,EAAE,gBAAgB,EAAE;EAChD,sBAAsB,eAAe,EAAE,gBAAgB,EAAE;EACzD,uBAAuB,eAAe,EAAE;EACxC,qEAAqE,iBAAiB,EAAE,iBAAiB,EAAE;EAC3G,yBAAyB,sBAAsB,EAAE,uBAAuB,EAAE,QAAQ,EAAE;EACpF,iBAAiB,kBAAkB,EAAE;EACrC,gBAAgB,uBAAuB,EAAE;EACzC,gBAAgB,uBAAuB,EAAE;AAC3C;;AAEA;EACE,wBAAwB,UAAU,EAAE,gBAAgB,EAAE;EACtD,sBAAsB,uBAAuB,EAAE;EAC/C,aAAa,iBAAiB,EAAE,iBAAiB,EAAE;EACnD,sBAAsB,eAAe,EAAE,gBAAgB,EAAE;EACzD,uBAAuB,eAAe,EAAE;EACxC,qEAAqE,iBAAiB,EAAE,eAAe,EAAE;EACzG,iBAAiB,kBAAkB,EAAE;EACrC,gBAAgB,uBAAuB,EAAE;EACzC,gBAAgB,uBAAuB,EAAE,QAAQ,EAAE;AACrD","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@300;400;500;600;700;800&family=Lora:ital,wght@0,400;0,600;1,400&display=swap');\n\n/* ======================================\n   DESIGN TOKENS — Pyate Blue Brand\n   Matched to: white navbar, #f0f2f5 page bg,\n   #1565C0 / #1976D2 primary blue\n====================================== */\n:root {\n  --brand:          #1565C0;\n  --brand-mid:      #1976D2;\n  --brand-light:    #42A5F5;\n  --brand-soft:     #E8F1FB;\n  --brand-glow:     rgba(21, 101, 192, 0.15);\n  --brand-glow-md:  rgba(21, 101, 192, 0.25);\n  --accent:         #0097A7;\n  --accent-soft:    #E0F4F7;\n  --surface:        #ffffff;\n  --surface-2:      #F5F7FA;\n  --surface-3:      #EBF1FB;\n  --page-bg:        #F0F2F5;        /* matches app grey background */\n  --border:         #DCE8F8;\n  --border-strong:  #BBCFF5;\n  --text-primary:   #0C1A2E;\n  --text-secondary: #334D6E;\n  --text-muted:     #7090B0;\n  --success:        #16A34A;\n  --danger:         #DC2626;\n  --danger-soft:    #FFF0F0;\n  --font:           'Plus Jakarta Sans', sans-serif;\n  --font-serif:     'Lora', serif;\n  --ease:           cubic-bezier(0.16, 1, 0.3, 1);\n  --radius-sm:      8px;\n  --radius-md:      14px;\n  --radius-lg:      22px;\n  --shadow-sm:      0 1px 3px rgba(0,0,0,0.06), 0 4px 12px rgba(21,101,192,0.06);\n  --shadow-md:      0 4px 16px rgba(0,0,0,0.07), 0 12px 32px rgba(21,101,192,0.09);\n  --shadow-lg:      0 8px 30px rgba(0,0,0,0.10), 0 24px 56px rgba(21,101,192,0.12);\n  --shadow-focus:   0 0 0 3px rgba(21,101,192,0.18);\n}\n\n* { box-sizing: border-box; }\n\n/* ======================================\n   PAGE BACKGROUND — matches app grey\n====================================== */\nbody {\n  background: var(--page-bg);\n  min-height: 100vh;\n  font-family: var(--font);\n}\n\n/* ======================================\n   MAIN CONTAINER\n====================================== */\n.about_container-edit {\n  display: flex;\n  justify-content: center;\n  font-family: var(--font);\n  width: 100%;\n  max-width: 860px;\n  margin: 28px auto;\n  border: 1px solid var(--border-strong);\n  border-radius: var(--radius-lg);\n  overflow: hidden;\n  background: var(--surface);\n  box-shadow: var(--shadow-md);\n  position: relative;\n  transition: box-shadow 0.3s var(--ease);\n}\n\n.about_container-edit:hover {\n  box-shadow: var(--shadow-lg);\n}\n\n/* Decorative top accent bar — Pyate blue */\n.about_container-edit::before {\n  content: '';\n  position: absolute;\n  top: 0; left: 0; right: 0;\n  height: 4px;\n  background: linear-gradient(90deg, var(--brand) 0%, var(--brand-light) 60%, var(--accent) 100%);\n  z-index: 2;\n}\n\n/* ======================================\n   CONTENT AREA\n====================================== */\n.about_content-edit {\n  width: 100%;\n  padding: 38px 42px 44px;\n  text-align: left;\n}\n\n/* ======================================\n   HEADER\n====================================== */\n.header-container-edit {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 28px;\n  padding-bottom: 18px;\n  border-bottom: 2px solid var(--brand-soft);\n  position: relative;\n}\n\n.header-container-edit h2 {\n  font-family: var(--font);\n  font-size: 22px;\n  font-weight: 800;\n  color: var(--brand);\n  letter-spacing: -0.4px;\n  margin: 0;\n  position: relative;\n}\n\n.header-container-edit h2::after {\n  content: '';\n  position: absolute;\n  bottom: -20px;\n  left: 0;\n  width: 36px;\n  height: 3px;\n  background: linear-gradient(90deg, var(--brand), var(--accent));\n  border-radius: 100px;\n}\n\n/* Section headings */\n.about_content-edit h3 {\n  font-family: var(--font);\n  font-size: 10.5px;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 1.4px;\n  color: var(--brand-light);\n  margin: 24px 0 8px;\n  padding: 0;\n}\n\n/* ======================================\n   PARAGRAPH CARDS\n====================================== */\n.paragraph-container-edit {\n  margin-bottom: 12px;\n  padding: 16px 20px;\n  background: var(--surface-2);\n  border: 1px solid var(--border);\n  border-left: 4px solid var(--brand-soft);\n  border-radius: var(--radius-md);\n  transition: border-left-color 0.22s var(--ease), box-shadow 0.22s var(--ease), background 0.2s;\n}\n\n.paragraph-container-edit:hover {\n  border-left-color: var(--brand-mid);\n  background: var(--surface);\n  box-shadow: var(--shadow-sm);\n}\n\n.para-edit {\n  font-family: var(--font-serif);\n  font-size: 15.5px;\n  line-height: 1.8;\n  color: var(--text-secondary);\n  margin: 0;\n}\n\n/* ======================================\n   ADDRESS SECTION\n====================================== */\n.about_content-edit > div {\n  background: linear-gradient(135deg, var(--surface-3) 0%, var(--surface-2) 100%);\n  border: 1px solid var(--border);\n  border-radius: var(--radius-md);\n  padding: 18px 22px;\n  margin-top: 8px;\n}\n\n.about_content-edit > div p {\n  font-size: 14px;\n  font-weight: 500;\n  color: var(--text-secondary);\n  margin: 5px 0;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.about_content-edit > div p::before {\n  content: '▸';\n  color: var(--brand-light);\n  font-size: 13px;\n  line-height: 1;\n  flex-shrink: 0;\n}\n\n/* Website link */\n.about_content-edit a {\n  color: var(--brand);\n  text-decoration: none;\n  font-weight: 600;\n  font-size: 14px;\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  padding: 2px 0;\n  border-bottom: 1.5px solid var(--brand-soft);\n  transition: color 0.18s, border-color 0.18s;\n}\n\n.about_content-edit a:hover {\n  color: var(--accent);\n  border-bottom-color: var(--accent);\n}\n\n/* No address fallback text */\n.about_content-edit > p {\n  font-size: 13.5px;\n  color: var(--text-muted);\n  font-style: italic;\n  margin: 8px 0 0;\n}\n\n/* ======================================\n   EDITABLE INPUTS\n====================================== */\n.editable-text-edit {\n  width: 100%;\n  min-height: 130px;\n  padding: 13px 16px;\n  font-size: 14px;\n  font-family: var(--font);\n  border: 1.5px solid var(--border-strong);\n  border-radius: var(--radius-sm);\n  background: var(--surface-2);\n  outline: none;\n  line-height: 1.7;\n  resize: vertical;\n  color: var(--text-primary);\n  transition: border-color 0.2s, box-shadow 0.2s, background 0.2s;\n}\n\n.editable-text-edit:focus {\n  border-color: var(--brand-mid);\n  box-shadow: var(--shadow-focus);\n  background: #fff;\n}\n\n.editable-input-edit {\n  width: 100%;\n  padding: 10px 14px;\n  font-size: 14px;\n  font-family: var(--font);\n  border: 1.5px solid var(--border-strong);\n  border-radius: var(--radius-sm);\n  background: var(--surface-2);\n  outline: none;\n  color: var(--text-primary);\n  transition: border-color 0.2s, box-shadow 0.2s, background 0.2s;\n}\n\n.editable-input-edit:focus {\n  border-color: var(--brand-mid);\n  box-shadow: var(--shadow-focus);\n  background: #fff;\n}\n\n/* ======================================\n   BUTTONS\n====================================== */\n.edit_button-edit {\n  padding: 8px 20px;\n  background: linear-gradient(135deg, var(--brand) 0%, var(--brand-mid) 100%);\n  color: white;\n  border: none;\n  border-radius: 100px;\n  cursor: pointer;\n  font-family: var(--font);\n  font-size: 13px;\n  font-weight: 700;\n  letter-spacing: 0.1px;\n  box-shadow: 0 2px 10px var(--brand-glow);\n  transition: transform 0.2s var(--ease), box-shadow 0.2s var(--ease);\n  margin-left: 10px;\n}\n\n.edit_button-edit:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 5px 18px var(--brand-glow-md);\n}\n\n.add-btn-edit,\n.save-btn-edit {\n  padding: 8px 20px;\n  background: linear-gradient(135deg, var(--brand) 0%, var(--brand-mid) 100%);\n  color: white;\n  border: none;\n  border-radius: 100px;\n  cursor: pointer;\n  font-family: var(--font);\n  font-size: 13px;\n  font-weight: 700;\n  box-shadow: 0 2px 10px var(--brand-glow);\n  transition: transform 0.2s var(--ease), box-shadow 0.2s var(--ease);\n}\n\n.add-btn-edit:hover,\n.save-btn-edit:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 5px 18px var(--brand-glow-md);\n}\n\n.delete-btn-edit {\n  padding: 7px 16px;\n  background: var(--danger-soft);\n  color: var(--danger);\n  border: 1.5px solid #FECACA;\n  border-radius: 100px;\n  cursor: pointer;\n  font-family: var(--font);\n  font-size: 12.5px;\n  font-weight: 700;\n  margin-top: 10px;\n  transition: all 0.18s var(--ease);\n}\n\n.delete-btn-edit:hover {\n  background: var(--danger);\n  color: white;\n  border-color: var(--danger);\n  transform: translateY(-1px);\n}\n\n.cancel-btn-edit {\n  padding: 8px 20px;\n  background: var(--surface-2);\n  color: var(--text-secondary);\n  border: 1.5px solid var(--border-strong);\n  border-radius: 100px;\n  cursor: pointer;\n  font-family: var(--font);\n  font-size: 13px;\n  font-weight: 600;\n  transition: all 0.18s var(--ease);\n}\n\n.cancel-btn-edit:hover {\n  background: var(--border);\n  color: var(--text-primary);\n}\n\n.add-paragraph-edit {\n  margin-top: 20px;\n}\n\n/* ======================================\n   MODAL\n====================================== */\n.about-modal-overlay {\n  position: fixed;\n  top: 0; left: 0; right: 0; bottom: 0;\n  background: rgba(10, 20, 40, 0.5);\n  backdrop-filter: blur(8px);\n  z-index: 1000;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.about-modal {\n  background: var(--surface);\n  border-radius: var(--radius-lg);\n  max-width: 780px;\n  width: 92%;\n  max-height: 90vh;\n  overflow-y: auto;\n  outline: none;\n  box-shadow: var(--shadow-lg);\n  border: 1px solid var(--border-strong);\n  position: relative;\n  top: unset;\n  left: unset;\n  transform: none;\n  animation: modalIn 0.28s var(--ease);\n}\n\n@keyframes modalIn {\n  from { opacity: 0; transform: scale(0.95) translateY(18px); }\n  to   { opacity: 1; transform: scale(1) translateY(0); }\n}\n\n.about-modal::before {\n  content: '';\n  display: block;\n  height: 4px;\n  background: linear-gradient(90deg, var(--brand) 0%, var(--brand-light) 60%, var(--accent) 100%);\n  border-radius: var(--radius-lg) var(--radius-lg) 0 0;\n}\n\n.modal-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 22px 30px 18px;\n  border-bottom: 1px solid var(--border);\n}\n\n.modal-header h2,\n.modal-header h3 {\n  font-family: var(--font);\n  font-size: 18px;\n  font-weight: 800;\n  color: var(--brand);\n  margin: 0;\n  letter-spacing: -0.2px;\n}\n\n.modal-close-btn {\n  background: var(--surface-2);\n  border: 1.5px solid var(--border-strong);\n  width: 34px;\n  height: 34px;\n  border-radius: 50%;\n  font-size: 16px;\n  cursor: pointer;\n  color: var(--text-muted);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.18s var(--ease);\n  line-height: 1;\n  flex-shrink: 0;\n}\n\n.modal-close-btn:hover {\n  background: var(--danger-soft);\n  border-color: #FECACA;\n  color: var(--danger);\n}\n\n.modal-content {\n  margin: 30px auto;\n  padding: 22px 30px;\n  width: 100%;\n}\n\n.form-section {\n  margin-bottom: 24px;\n  padding: 20px 22px;\n  background: var(--surface-2);\n  border: 1px solid var(--border);\n  border-radius: var(--radius-md);\n}\n\n.form-section h3 {\n  margin-bottom: 16px;\n  color: var(--brand);\n  font-size: 11px;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 1.2px;\n}\n\n.form-field {\n  margin-bottom: 14px;\n}\n\n.form-field label {\n  display: block;\n  margin-bottom: 5px;\n  font-size: 12px;\n  font-weight: 700;\n  color: var(--text-secondary);\n  letter-spacing: 0.2px;\n  text-transform: uppercase;\n}\n\n.modal-footer {\n  display: flex;\n  justify-content: flex-end;\n  gap: 10px;\n  padding: 18px 30px 26px;\n  border-top: 1px solid var(--border);\n  background: var(--surface-2);\n}\n\n.paragraph-edit-container {\n  margin-bottom: 12px;\n  padding: 13px 17px;\n  background: var(--surface);\n  border: 1px solid var(--border-strong);\n  border-radius: var(--radius-sm);\n}\n\n/* ======================================\n   RESPONSIVE\n====================================== */\n@media (max-width: 992px) {\n  .about_container-edit { width: 95%; margin: 18px auto; }\n  .about_content-edit { padding: 26px 26px 30px; }\n  .para-edit { font-size: 15px; }\n  .editable-text-edit { font-size: 13px; min-height: 80px; }\n  .header-container-edit { flex-direction: column; align-items: flex-start; gap: 12px; }\n  .edit_button-edit { margin-left: 0; }\n}\n\n@media (max-width: 768px) {\n  .about_container-edit { width: 96%; margin: 12px auto; }\n  .about_content-edit { padding: 22px 18px 26px; }\n  .para-edit { font-size: 14px; line-height: 1.7; }\n  .editable-text-edit { font-size: 13px; min-height: 70px; }\n  .editable-input-edit { font-size: 13px; }\n  .edit_button-edit, .add-btn-edit, .delete-btn-edit, .save-btn-edit { padding: 7px 14px; font-size: 12.5px; }\n  .header-container-edit { flex-direction: column; align-items: flex-start; gap: 8px; }\n  .modal-content { padding: 16px 18px; }\n  .modal-header { padding: 16px 18px 12px; }\n  .modal-footer { padding: 14px 18px 20px; }\n}\n\n@media (max-width: 480px) {\n  .about_container-edit { width: 97%; margin: 8px auto; }\n  .about_content-edit { padding: 18px 14px 22px; }\n  .para-edit { font-size: 13.5px; line-height: 1.65; }\n  .editable-text-edit { font-size: 12px; min-height: 55px; }\n  .editable-input-edit { font-size: 12px; }\n  .edit_button-edit, .add-btn-edit, .delete-btn-edit, .save-btn-edit { padding: 6px 12px; font-size: 12px; }\n  .modal-content { padding: 12px 14px; }\n  .modal-header { padding: 14px 14px 10px; }\n  .modal-footer { padding: 12px 14px 18px; gap: 8px; }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
